import { render } from "./DigiNum.vue?vue&type=template&id=33584aee"
import script from "./DigiNum.vue?vue&type=script&lang=js"
export * from "./DigiNum.vue?vue&type=script&lang=js"

import "./DigiNum.vue?vue&type=style&index=0&id=33584aee&lang=scss"
script.render = render

export default script